import { TooltipPosition, TooltipTrigger } from "@/types/library/Tooltips";
import type { ITooltipWrapper } from "@/types/library/Tooltips";
import Tippy from "@tippyjs/react";
import "tippy.js/animations/scale.css";
import "tippy.js/dist/svg-arrow.css";
import Icon from "../Icon";

const TooltipWrapper: React.FC<ITooltipWrapper> = ({
  id = "",
  content,
  icon,
  trigger = TooltipTrigger.Hover,
  position = TooltipPosition.Top,
  interactive = false,
}) => {
  return (
    <div id={id} data-testid={id}>
      <Tippy
        animation="scale"
        content={content}
        placement={position}
        trigger={trigger}
        interactive={interactive}
        delay={200}
      >
        <div>
          <Icon icon={icon} className="text-dines-purple-darkest" />
        </div>
      </Tippy>
    </div>
  );
};

export default TooltipWrapper;
